import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import ActivityModal from './components/ActivityModal.jsx';
import SiteWalkerPage from './pages/SiteWalkerPage.jsx';
import SplashPage from './pages/SplashPage.jsx';
import SignUpPage from './pages/SignUpPage.jsx';
import SignInPage from './pages/SignInPage.jsx';
import SignInHelpPage from './pages/SignInHelpPage.jsx';
import MainPage from './pages/MainPage.jsx';
import SetupPage from './pages/SetupPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import VerifyPage from './pages/VerifyPage.jsx';
import InvitePage from './pages/InvitePage.jsx';
import ResetPasswordPage from './pages/ResetPasswordPage.jsx';
import LayoutPage from './pages/LayoutPage.jsx';
import SuperAdminPage from './pages/SuperAdminPage.jsx';
import '../style/allstyles.less';

import { StateProvider } from './context/state.jsx';
import { initialState, reducer } from './context/store.js';

const AppLayout = () => (
	<SiteWalkerPage>
		<Outlet />
	</SiteWalkerPage>
);

const MainPageRoute = ({
	setProximityDistanceState,
	setMapPinMyLocationState,
	proximityDistance,
	mapPinMyLocation,
	mapPinPickMode,
	setMapPinPickMode
}) => (
	<>
		<MainPage
			setProximityDistance={setProximityDistanceState}
			setMapPinMyLocation={setMapPinMyLocationState}
			proximityDistance={proximityDistance}
			mapPinMyLocation={mapPinMyLocation}
			mapPinPickMode={mapPinPickMode}
			setMapPinPickMode={setMapPinPickMode}
		/>
		<Outlet />
	</>
);

MainPageRoute.propTypes = {
	setProximityDistanceState: PropTypes.func.isRequired,
	setMapPinMyLocationState: PropTypes.func.isRequired,
	proximityDistance: PropTypes.number,
	mapPinMyLocation: PropTypes.shape({
		lat: PropTypes.number,
		lng: PropTypes.number
	}),
	mapPinPickMode: PropTypes.bool,
	setMapPinPickMode: PropTypes.func
};

const App = () => {
	const [proximityDistance, setProximityDistance] = useState(null);
	const [mapPinMyLocation, setMapPinMyLocation] = useState(null);
	const [mapPinPickMode, setMapPinPickMode] = useState(false);

	const setProximityDistanceState = (proximityDistance, callback = false) => {
		setProximityDistance(proximityDistance);
		if (typeof callback === 'function') callback();
	};

	const setMapPinMyLocationState = (lat, lng) => {
		const mapPinMyLocation = lat === null ? null : { lat, lng };
		setMapPinMyLocation(mapPinMyLocation);
		if (lat !== null) {
			setMapPinPickMode(false);
		}
	};

	return (
		<StateProvider initialState={initialState} reducer={reducer}>
			<BrowserRouter>
				<Routes>
					<Route element={<AppLayout />}>
						<Route path="/" element={<SplashPage />} />
						<Route path="/signup/*" element={<SignUpPage />} />
						<Route path="/signin/*" element={<SignInPage />} />
						<Route path="/signinhelp/*" element={<SignInHelpPage />} />
						<Route path="/setup/*" element={<SetupPage />} />
						<Route path="/superadmin/*" element={<SuperAdminPage />} />
						<Route path="/about/*" element={<AboutPage />} />
						<Route path="/privacy/*" element={<PrivacyPage />} />
						<Route path="/verify/:Token" element={<VerifyPage />} />
						<Route path="/invite/:Token" element={<InvitePage />} />
						<Route path="/resetpassword/id/:id/key/:key" element={<ResetPasswordPage />} />
						<Route path="/layout/:layoutId/*" element={<LayoutPage />} />
						<Route
							path="/app/*"
							element={
								<MainPageRoute
									setProximityDistanceState={setProximityDistanceState}
									setMapPinMyLocationState={setMapPinMyLocationState}
									proximityDistance={proximityDistance}
									mapPinMyLocation={mapPinMyLocation}
									mapPinPickMode={mapPinPickMode}
									setMapPinPickMode={setMapPinPickMode}
								/>
							}
						>
							<Route
								path="dataset/:datasetId/activity/:activityId"
								element={<ActivityModal />}
							/>
						</Route>
					</Route>
				</Routes>
			</BrowserRouter>
		</StateProvider>
	);
};

export default App;
